import { render, staticRenderFns } from "./editSkinDialog.vue?vue&type=template&id=a87812e4&scoped=true&"
import script from "./editSkinDialog.vue?vue&type=script&lang=js&"
export * from "./editSkinDialog.vue?vue&type=script&lang=js&"
import style0 from "./editSkinDialog.vue?vue&type=style&index=0&id=a87812e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87812e4",
  null
  
)

export default component.exports